import { useDispatch } from 'react-redux'
import { addToast } from 'shared/state/toastSlice'

export interface useToastParams {
    title: string
    message: string
    timestamp?: string
    action?: {
        title: string
        onClick: () => void
    }
    stayOpen?: boolean
    severity?: 'info' | 'warning' | 'error' | 'success'
    inline?: boolean
    id?: string // id will be generated based on timestamp if not provided
}

const useToast = () => {
    const dispatch = useDispatch()

    const dispatchToast = ({
        title,
        message,
        action,
        timestamp,
        stayOpen = false,
        severity = 'error',
        inline = false,
        id = undefined,
    }: useToastParams) => {
        dispatch(
            addToast({
                title,
                message,
                severity,
                timestamp,
                inline,
                actionButtonTitle: action?.title,
                onActionButtonClick: action?.onClick,
                timeout: stayOpen ? undefined : 5000,
                id,
            })
        )
    }

    return dispatchToast
}

export default useToast
